module.exports = __webpack_public_path__ + "img/map-active.47129a12.png";